import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '地址指南', path: '/category/address-guide' },
      { label: '访问帮助', path: '/category/access-help' },
    ],
  },
  {
    title: '实用资源',
    links: [
      { label: '更新动态', path: '/category/update-news' },
      { label: '常见问题', path: '/category/faq' },
      { label: '安全提示', path: '/category/security-tips' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '免责声明', path: '/about' },
      { label: '联系方式', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl text-primary-500">
              海角最新地址
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              海角最新地址官方入口实时更新，提供最新、最稳定的海角访问地址。收藏本站，随时获取海角最新地址。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 海角最新地址·官方入口实时更新. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-500">
            本站为海角地址信息聚合平台，所有地址信息仅供参考
          </p>
        </div>
      </div>
    </footer>
  );
}